import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import moment from 'moment';
const isSameRange = (first, second) => {
    const { startDate: fStart, endDate: fEnd } = first;
    const { startDate: sStart, endDate: sEnd } = second;
    if (fStart && sStart && fEnd && sEnd) {
        return moment(fStart).isSame(sStart, 'day') && moment(fEnd).isSame(sEnd, 'day');
    }
    return false;
};
const DefinedRanges = props => {
    return (<List>
      {props.ranges.map((range, idx) => (<ListItem button key={idx} onClick={() => props.setRange(range)}>
          <ListItemText primaryTypographyProps={{
                variant: 'body2',
                style: {
                    fontWeight: isSameRange(range, props.selectedRange) ? 'bold' : 'normal'
                }
            }}>
            {range.label}
          </ListItemText>
        </ListItem>))}
    </List>);
};
export default DefinedRanges;
